export default __webpack_public_path__ + "static/media/info.cea38204.svg";